<template>
  <div class="waylist-element">
    <button-item
      :icons="canRemove ? ['x'] : []"
      @click="openInOverlay"
      @click:x="remove"
    >
      {{ itemTitle }}
    </button-item>
    <div v-if="showImpulse" class="waylist__changeimpulseinfo">
      <div class="waylist-element__change">
        <span>{{ $t("labels.changeImpulse") }}</span
        ><br />
        <span class="text-annotation">
          {{ startImpulse.pointsToAdd || 0 }}% *
          {{ impulseFraction }}
        </span>
      </div>
      <div class="ta-r">{{ endImpulseOperator }}{{ absEndImpulsePoints }}</div>
      <div>%</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import ButtonItem from "@core/input/ButtonItem.vue";

const props = withDefaults(defineProps<{
  wayImpulses: Record<number, Record<string, Record<number, { pointsToAdd: number | null }>>>;
  canRemove?: boolean;
  roundIndex?: number;
  startItemId?: number;
  startItemType?: "target" | "resource" | "index";
  endItemId?: number;
  endItemType?: "target" | "resource" | "index";
  itemTitle?: string;
  showImpulse?: boolean;
}>(), {
  canRemove: false,
  roundIndex: 0,
  startItemId: 0,
  startItemType: "target",
  endItemId: 0,
  endItemType: "target",
  itemTitle: "",
  showImpulse: true
});

const emit = defineEmits<{
  (e: "open", mouseEvent: MouseEvent): void;
  (e: "remove", mouseEvent: MouseEvent): void;
}>();

const startImpulse = computed((): { pointsToAdd?: number | null } => {
  if (!props.wayImpulses) return {};

  const impulses = props.wayImpulses[props.roundIndex];
  if (!impulses) return {};

  return impulses?.[props.startItemType]?.[props.startItemId] || {};
});

const endImpulse = computed((): { pointsToAdd?: number | null } => {
  if (!props.wayImpulses) return {};

  const impulses = props.wayImpulses[props.roundIndex + 1];
  if (!impulses) return {};

  return impulses[props.endItemType][props.endItemId] || {};
});

const endImpulseOperator = computed(() => {
  if (!endImpulse.value.pointsToAdd) return "";
  if (endImpulse.value.pointsToAdd > 0) return "+";
  return "-";
});

const absEndImpulsePoints = computed(() => {
  if (!endImpulse.value.pointsToAdd) return 0;
  return Math.abs(endImpulse.value.pointsToAdd);
});

const impulseFraction = computed(() => {
  if (!startImpulse.value.pointsToAdd || !endImpulse.value.pointsToAdd)
    return "—";
  return (
    endImpulse.value.pointsToAdd / startImpulse.value.pointsToAdd
  ).toFixed(2);
});

function openInOverlay(mouseEvent: MouseEvent) {
  emit("open", mouseEvent);
}
function remove(mouseEvent: MouseEvent) {
  emit("remove", mouseEvent);
}
</script>

<style lang="scss">
.waylist-element {
  &__change {
    padding-left: 0.75rem;
  }
}
</style>
